import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

interface CTASectionProps {
    onGetStarted: () => void;
}

export const CTASection: React.FC<CTASectionProps> = ({ onGetStarted }) => {
    return (
        <section className="cta-section relative overflow-hidden py-32 flex items-center justify-center bg-[#0a0a0f]">
            {/* Background Glow */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[500px] bg-indigo-600/10 blur-[100px] rounded-full pointer-events-none" />

            <div className="max-w-4xl mx-auto px-4 relative z-10 text-center flex flex-col items-center">
                <motion.h2
                    className="text-4xl md:text-5xl font-bold text-white mb-6 tracking-tight leading-tight"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5 }}
                >
                    Ready to revolutionize your <br />
                    <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-zinc-500">note-taking?</span>
                </motion.h2>

                <motion.p
                    className="text-lg md:text-xl text-zinc-400 mb-10 max-w-2xl mx-auto leading-relaxed"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: 0.1 }}
                >
                    Join thousands of students, researchers, and creatives who are
                    thinking bigger with NoteSpace.
                </motion.p>

                <motion.button
                    onClick={onGetStarted}
                    className="btn-shiny inline-flex items-center gap-2 text-lg px-10 py-4 rounded-full font-semibold text-white bg-indigo-600 hover:bg-indigo-500 transition-all shadow-[0_0_20px_rgba(99,102,241,0.3)] hover:shadow-[0_0_30px_rgba(99,102,241,0.5)] border border-white/10"
                    initial={{ opacity: 0, scale: 0.9 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    transition={{ duration: 0.3 }}
                >
                    Get Started for Free <ArrowRight className="w-5 h-5" />
                </motion.button>
            </div>
        </section >
    );
};
